






































import { Component, Mixins, Prop } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { DataModules } from "@/store/modules/data";
import GatewayOperationHandlerMixin from "@/mixins/gatewayOperationHandlerMixin";

@Component({
  components: {
    "brand-gateways-provider": () =>
      import("@/components/app/global/payments/brandGatewaysProvider.vue"),
    "no-stored-brand-gateways-msg": () =>
      import("@/components/app/global/payments/noStoredBrandGatewaysMsg.vue"),
    "client-payment-methods-list": () =>
      import("@/components/app/global/payments/clientPaymentMethodsList.vue")
  }
})
export default class ClientPaymentMethodsView extends Mixins(
  GatewayOperationHandlerMixin
) {
  // Props
  @Prop({ required: true })
  public client!: IClient;
  // Methods
  public addPaymentMethod() {
    this.$store.dispatch(
      `data/${DataModules.CLIENTS_PAYMENT_DETAILS}/openAddModal`,
      {
        vm: this,
        parent: this,
        props: {
          client: this.client,
          clientId: this.client.id,
          brandId: this.client.brand_id
        },
        events: {
          "payment-method-added": () => {
            if (!this.$refs.paymentMethods) return;
            // @ts-ignore
            this.$refs.paymentMethods.getPaymentMethods();
          }
        }
      }
    );
  }
}
